import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import api from 'api/axios/foka'
import SelectBox from 'components/form/SelectBox'
import Loading from 'components/loading/Loading'
import { isNil } from 'lodash'

const CreateAdGroupModal = ({ handleClose, handleCreate }) => {
  const [campaignId, setCampaignId] = useState()
  const [campaigns, setCampaigns] = useState([])
  const [isLoading, setLoading] = useState(false)
  const isEmpty = !isLoading && campaigns.length === 0
  useEffect(() => {
    ;(async () => {
      setLoading(true)
      const {
        data: { campaigns: response },
      } = await api.ad.getNotDeletedCampaigns()
      setCampaigns(response)
      setLoading(false)
    })()
  }, [])
  const handleConfirm = () => {
    handleCreate(campaignId)
  }
  return (
    <ConfirmModal
      title="광고그룹 만들기"
      onConfirm={handleConfirm}
      handleClose={handleClose}
      confirmDisabled={isNil(campaignId)}>
      <p className="desc_copy">선택한 캠페인내 광고그룹이 생성 됩니다.</p>
      <div className="box_subcard">
        <strong className="tit_subcard">캠페인</strong>
        {isLoading ? (
          <div className="opt_select" style={{ height: 34 }}>
            <Loading />
          </div>
        ) : (
          <SelectBox
            value={campaignId}
            placeholder="캠페인을 선택하세요."
            onValueChange={setCampaignId}>
            {isEmpty ? (
              <SelectBox.Item value={null} text="캠페인 선택">
                캠페인이 없습니다.
              </SelectBox.Item>
            ) : (
              campaigns.map(({ id, name }) => (
                <SelectBox.Item key={id} value={id}>
                  {name} ({id})
                </SelectBox.Item>
              ))
            )}
          </SelectBox>
        )}
      </div>
    </ConfirmModal>
  )
}
CreateAdGroupModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleCreate: PropTypes.func,
}

export default CreateAdGroupModal
